import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function CategorySection() {
  const [activeCategory, setActiveCategory] = useState(categories[0].slug);
  const articles = getArticlesByCategory(activeCategory);
  const activeCat = categories.find((c) => c.slug === activeCategory);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            探索文章分类
          </h2>
          <p className="text-sm text-foreground-500">选择您感兴趣的分类，浏览相关内容</p>
        </div>

        <div className="flex items-center justify-center mb-10">
          <div className="inline-flex items-center bg-background-50 border border-secondary-200 rounded-full px-1 py-1 flex-wrap justify-center gap-1">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.slug)}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-secondary-100'
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        {activeCat && (
          <div className="mb-6 text-center">
            <p className="text-sm text-foreground-500">{activeCat.description}</p>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.slice(0, 6).map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to={`/category/${activeCategory}`}
            className="inline-flex items-center gap-1.5 px-6 py-2.5 text-sm font-medium text-primary-600 border border-primary-200 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            查看全部 {activeCat?.name} 文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}